import { useDealerGroupMembers } from '../hooks/useDealersQuery';
import { DealerDataTable } from './DealerDataTable';
import { Alert } from '@/shared/components';

interface DealerGroupMembersProps {
    dealerId: string;
}

/**
 * Read-only list of a dealer's ownership children. Ownership is set only
 * up-tree via each dealer's own form (AllowedParentSelect in DealerForm),
 * so this tab has no attach/detach affordances.
 */
export function DealerGroupMembers({ dealerId }: DealerGroupMembersProps) {
    const { data, isLoading, isError } = useDealerGroupMembers(dealerId);

    // Surface fetch failures explicitly. Without this, an errored query
    // (data === undefined) would fall through to `data ?? []` and render the
    // shared Table's empty state, telling the Admin there are no owned dealers
    // when the request actually failed. The error state stays distinct from
    // the genuine empty state (no rows returned) handled by the Table itself.
    if (isError) {
        return (
            <Alert variant="error">
                <span>Failed to load owned dealers.</span>
            </Alert>
        );
    }

    return (
        <DealerDataTable
            data={data ?? []}
            isLoading={isLoading}
            showGroupColumn={false}
        />
    );
}
